module.exports = "/**\n * Applies styles for users in high contrast mode. Note that this only applies\n * to Microsoft browsers. Chrome can be included by checking for the `html[hc]`\n * attribute, however Chrome handles high contrast differently.\n */\n/* Theme for the ripple elements.*/\n/* stylelint-disable material/no-prefixes */\n/* stylelint-enable */\n#main-navigation {\n  margin: 0;\n  padding: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/navigation/navigation.component.scss
// module id = ./src/app/core/components/navigation/navigation.component.scss
// module chunks = main